enum NewOrderItemDisplayType {
    PIC = "PIC",

    TITLE = "TITLE",

    SIMPLE_TITLE = "SIMPLE_TITLE",

    EXTERNAL_ID = "EXTERNAL_ID",

    SKU_PROPERTIES = "SKU_PROPERTIES",

    /**
     * 当订单仅有赠品时，不显示赠品不生效。即不勾选显示赠品，订单有需要展示赠品
     */
    GIFT = "GIFT",
}

export default NewOrderItemDisplayType;
